// React
import React, { useState } from 'react';

// FutureLab
import { ChatListDataInterface } from './ChatListItemsMobile';
import { getQueryResults } from '../../utilities/Chat';
import { ChatListItemsDesktopLoop } from './ChatListItemsDesktopLoop';
import { UserDetailsListItem } from '../../model';
import { LoggedInUserDetails } from '../../reducers/index';
import useIntersection from '../../hooks/useIntersection';

interface ChatListItemsMessages {
	loggedInUserDetail: LoggedInUserDetails;
	userListProfilesDetails: UserDetailsListItem[];
	chatListsItems: ChatListDataInterface[];
	filterQuery: any;
	setFilterQuery: any;
	callbackScroll: () => void;
	hasMore: boolean;
	isLoadingMore: boolean;
	showMessagePreview?: boolean;
	emptyActionLabel?: string;
	onEmptyAction?: () => void;
	scrollViewportClassName?: string;
}

export function ChatList(ChatListItemsMessages: ChatListItemsMessages) {
	const {
		loggedInUserDetail,
		userListProfilesDetails,
		filterQuery,
		chatListsItems,
		callbackScroll,
		hasMore,
		isLoadingMore,
		showMessagePreview = true,
		emptyActionLabel = 'Book a Session',
		onEmptyAction,
		scrollViewportClassName = 'h-[calc(100dvh-173px)] md:h-[calc(100dvh-173px)]',
	} =
		ChatListItemsMessages;
	const [chatsListRoot, setChatsListRoot] = useState<HTMLDivElement | null>(null);
	const [targetRef] = useIntersection({
		root: chatsListRoot,
		rootMargin: '0px 0px 240px',
		threshold: 0.01,
		callback: callbackScroll,
	});

	return (
		<>
			{chatListsItems.length > 0 ? (
				<div>
					{getQueryResults(chatListsItems, loggedInUserDetail, userListProfilesDetails, filterQuery).length >
					0 ? (
						<div ref={setChatsListRoot} className={`${scrollViewportClassName} overflow-y-auto`}>
							<ChatListItemsDesktopLoop
								chatListsItems={chatListsItems}
								loggedInUserDetails={loggedInUserDetail}
								userListProfilesDetails={userListProfilesDetails}
								filterQuery={filterQuery}
							targetRef={hasMore ? targetRef : null}
								showMessagePreview={showMessagePreview}
							/>
							{isLoadingMore && <div className="px-4 py-3 text-center text-sm text-muted-foreground">Loading chats...</div>}
						</div>
						) : (
						<div className="px-5 pt-10 text-center">
							<h2 className="pb-3 text-xl font-bold text-gray-900">No result found.</h2>
							<p className="text-base text-gray-600">Please refine your key words and try again</p>
						</div>
					)}
				</div>
			) : (
				<div className="px-5 pt-10 text-center">
					<h2 className="pb-3 text-xl font-bold text-gray-900">{onEmptyAction ? 'No messages yet' : "It's nice to chat with someone"}</h2>
					<p className="text-base text-gray-600">
						{onEmptyAction ? 'Open Contacts to start a conversation.' : 'No chatroom in your inbox, yet! Start to book a session with your mentor.'}
					</p>
					{onEmptyAction ? (
						<button
							className="mt-5 inline-flex min-h-11 items-center justify-center rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
							onClick={onEmptyAction}
							type="button"
						>
							{emptyActionLabel}
						</button>
					) : (
					<a
						className="mt-5 inline-flex min-h-11 items-center justify-center rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
						href="https://futurelab.global/discover/mentors?lang=en"
						rel="noreferrer"
						target="_blank"
					>
						{emptyActionLabel}
					</a>
					)}
				</div>
			)}
		</>
	);
}
